<template>
    <header>
        <div class="container" id="header">
            <div class="row top_header my-4">
                <div class="col-md-6">
                    <a class="logo" href="#"><img @click="ToHome" src="@/assets/images/logo.png" alt="logo"
                            class="img-fluid"></a>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-4 ps-0 pe-0">
                            <!-- <div class="form-floating">
                                <input type="text" class="form-control" id="top_search" placeholder="بحث">
                                <label for="search"> بحث <i class="bi bi-search"></i></label>
                            </div> -->
                        </div>
                        <div class="col-2 ps-0 ">
                            <!-- <div class="acc_links"><a href="#"><i class="bi bi-globe"></i> EN </a> </div> -->
                        </div>
                        <div class="col-2 ps-0 ">
                            <div class="acc_links" style="border-right: none !important;">
                                <a href="mailto:csoinfo@moi.gov.eg">
                                    <i class="bi bi-envelope"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-4 pe-0">
                            <div class="acc_links">

                                <!-- Not authenticated -->
                                <a @click="ToLogIn" v-if="!isAuthenticated" class="login-link">
                                    <i class="bi bi-person"></i>
                                    دخول / حسابي
                                </a>

                                <!-- Authenticated -->
                                <div v-else class="user-pill">

                                    <a class="login-link" @click="toggleMenu">
                                        <i class="bi bi-chevron-down small-arrow"></i>
                                        <i class="bi bi-person"></i>
                                        مرحباً {{ UserName }}                                        
                                    </a>

                                    <transition name="fade">
                                        <div v-if="showMenu" class="soft-dropdown">
                                            <a @click.stop="Logout">
                                                <i class="bi bi-box-arrow-right"></i>
                                                تسجيل الخروج
                                            </a>
                                        </div>
                                    </transition>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </header>
</template>

<script>
import { mapGetters } from "vuex";
import { buildLoginUrl } from "@/config";

export default {
    name: "HeaderComp",

    data() {
        return {
            showMenu: false
        };
    },

    computed: {
        ...mapGetters({
            isAuthenticated: "isAuthenticated",
            UserName: "StateUserName"
        })
    },

    methods: {

        toggleMenu() {
            this.showMenu = !this.showMenu;
        },

        ToHome() {
            this.$router.push({ name: "dashboard" });
        },

        ToProfile() {
            this.$router.push({ name: "profile" });
        },

        ToLogIn() {
            window.location.href = buildLoginUrl("/");
        },

        Logout() {
            this.$store.dispatch("logout");
        }

    }
};
</script>
